<div class="modal-header">
  <h4 class="modal-title" translate>{{ activity?.id ? 'ACTIVITY_EDIT' : 'ACTIVITY_CREATE' }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="submitForm">
    <div class="row" *ngIf="!activity?.id">
      <div class="col-12">
        <lib-gung-text-input
          [renderStatic]="true"
          [gungTranslate]="'CUSTOMER'"
          formControlName="customer"
        ></lib-gung-text-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <lib-gung-select-option-input
          *ngIf="!!customersResponsible && customersResponsible.length > 0; else customerResponsibleTextInput"
          gungTranslate="CUSTOMER_RESPONSIBLE"
          [optionsList]="customersResponsible"
          formControlName="customerResponsible"
        ></lib-gung-select-option-input>
        <ng-template #customerResponsibleTextInput>
          <lib-gung-text-input
            [gungTranslate]="'CUSTOMER_RESPONSIBLE'"
            formControlName="customerResponsible"
          ></lib-gung-text-input>
        </ng-template>
      </div>
    </div>
    <!-- <div class="row" *ngIf="activity?.id">
        <div class="col-12">
          <lib-meta-data-select-input formControlName="status" table="ACTIVITYINTERNALSTATUS" metaId="id" metaDisplay="name" prefix="@ACTIVITYINTERNALSTATUS" label="STATUS" hideEmptyOption="true" labelClass="col-12 font-weight-normal"></lib-meta-data-select-input>
        </div>
      </div> -->
    <div class="row">
      <div class="col-12">
        <lib-gung-date-picker
          label="ACTIVITY_DATE"
          [currentselectedDate]="submitForm.get('activityDate').value"
          [minInitialDate]="minDatePickerDate"
          (selectedDate)="updateDate($event)"
        ></lib-gung-date-picker>
        <lib-forms-message-error [controller]="submitForm.get('activityDate')"></lib-forms-message-error>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <ng-container *ngTemplateOutlet="searchElement"></ng-container>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <!-- <label for="contact" translate>CONTACT</label> -->
          <div formArrayName="contacts">
            <div *ngFor="let contact of contacts.controls; let i = index">
              <div class="d-flex mb-2">
                <!-- [formGroupName]="i" -->
                <input class="form-control" type="text" [formControlName]="i" />
                <button type="button" class="btn btn-danger align-self-end" (click)="removeContact(i)">
                  <i class="fas fa-times-circle"></i>
                </button>
              </div>
            </div>
          </div>
          <button type="button" class="btn btn-primary d-block" (click)="addContact()">
            <span translate>ADD_CONTACT</span><i class="fas fa-plus-circle ml-1"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <lib-meta-data-select-input
          formControlName="type"
          table="ACTIVITYINTERNALTYPE"
          metaId="id"
          metaDisplay="name"
          prefix="@ACTIVITYINTERNALTYPE"
          hideEmptyOption="true"
          label="ACTIVITY_TYPE"
          labelClass="col-12 font-weight-normal"
        ></lib-meta-data-select-input>
        <div
          *ngIf="submitForm.get('type').invalid && (submitForm.get('type').dirty || submitForm.get('type').touched)"
          class="alert alert-danger p-1"
        >
          <span translate>FORM_ERROR_REQUIRED</span>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!activity?.id">
      <div class="col-12">
        <div class="form-group">
          <label for="comment" class="control-label" translate>COMMENT</label>
          <textarea
            class="form-control"
            type="text"
            name="comment"
            id="comment"
            formControlName="comment"
            rows="5"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!activity?.id">
      <div class="col-12">
        <div class="form-group">
          <label class="w-100" for="file-upload" translate>ATTACH_FILES</label>
          <input
            #inputFile
            type="file"
            class=""
            id="file-upload"
            aria-describedby="file-upload"
            [multiple]="multipleFiles"
            (change)="onFileSelect($event.target.files)"
            [disabled]="disabled ? true : null"
          />
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close('Cance click')" translate>CANCEL</button>
  <button type="button" class="btn btn-primary" [disabled]="disabled ? true : null" (click)="onSave()" translate>
    SAVE
  </button>
</div>

<ng-template #searchElement>
  <div class="">
    <label for="typeahead-prevent-manual-entry" translate>CONTACT</label>
    <input
      #searchInput
      id="typeahead-prevent-manual-entry"
      type="text"
      class="form-control"
      [(ngModel)]="modelSearch"
      [ngbTypeahead]="search"
      [inputFormatter]="formatter"
      [resultFormatter]="resultFormatter"
      (selectItem)="selectItem($event, searchInput)"
      placeholder="{{ 'CONTACT' | translate }}"
      (focusout)="focusout($event, modelSearch)"
      (ngModelChange)="ngModelChange($event, searchInput)"
      [showHint]="false"
      [editable]="false"
    />
  </div>
</ng-template>
